export default "__VITE_ASSET__DMLet$6j__"